import { atom, selector } from "recoil"
import { accountSelector } from "src/recoil/selectors/account/accountSelector"

export const schoolIdState = atom({
  key: "atoms/account/schoolIdState",
  default: selector({
    key: "atoms/account/schoolIdState_default",
    get: ({ get }) => {
      const account = get(accountSelector)
      return account?.schoolId
    },
  }),
})
